import { useQuery } from "@tanstack/react-query";
import { api } from "./client";
import type { StatsOut } from "./types";

export function useStats() {
  return useQuery({
    queryKey: ["stats"],
    queryFn: () => api<StatsOut>("/stats"),
  });
}
